import { createContext } from 'react';

import { PageContextType, PageLayout } from '../../types';

export const PageContext = createContext<PageContextType>({
  id: '',
  name: '',
  title: '',
  breadcrumbs: [],
  allSlugs: [],
  sidebarContents: [],
  versions: [],
  defaultVersion: '',
  version: '',
  slug: '',
  canonical: '',
  product: '',
  layout: PageLayout.Basic,
  search: {},
});
